import * as Sentry from '@sentry/remix';

import type { UserProfile } from '~/user/Profile';
import { sha256 } from '~/utils/hash';

// The defined fields are either required by Facebook or recommended
// for better event matching quality, tracking and ad conversion.
// https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/server-event
export type ServerEventData = {
  [key: string]: string | object | number | null;
  action_source: string;
  event_id: string;
  event_name: string;
  user_data: {
    client_ip_address: string | null;
    client_user_agent: string;
    fbc?: string;
    fbp?: string;
  };
}[];

async function sendServerEvent(
  data: ServerEventData,
  FACEBOOK_PIXEL_ID: string,
  FACEBOOK_PIXEL_TOKEN: string
) {
  const baseUrl = 'https://graph.facebook.com/v22.0';

  const request = await fetch(
    `${baseUrl}/${FACEBOOK_PIXEL_ID}/events?access_token=${FACEBOOK_PIXEL_TOKEN}`,
    {
      body: JSON.stringify({ data }),
      headers: { 'Content-Type': 'application/json' },
      method: 'POST'
    }
  );

  if (!request.ok) {
    Sentry.captureException(await request.json(), {
      extra: { message: 'Error sending facebook event' }
    });
  }
}

export async function getHashedProfile(profile?: UserProfile) {
  if (!profile) return {};

  const [em, fn, ln, ph] = await Promise.all([
    sha256(profile.email),
    sha256(profile.first_name),
    sha256(profile.last_name),
    sha256(profile.phone_number)
  ]);

  return { em, fn, ln, ph };
}

export default {
  getHashedProfile,
  sendServerEvent
};
